/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/asense/"

const ASENSE: CommunityData = {
  code: "asense",
  inviteCode: "asense",
  name: "a.sense",
  publicEventPages: true,
  thumbnail: "",
  favicon: "",
  defaultCurrency: "SEK",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/ase-080`,
  waitlist: false,
  socials: {},
  styles: {
    comingSoon: {
      bgColor: "#000000",
      hero: {
        desktop: `${S3_PREFIX}web-background.jpg`,
        mobile: `${S3_PREFIX}web-background-mobile.jpg`,
        style: "bg-[#111111]",
      },
      logo: {
        desktop: `${S3_PREFIX}web-alternative-logo.png`,
        mobile: `${S3_PREFIX}web-alternative-logo.png`,
        style: "w-[115px] h-[30px] sm:w-[192px] sm:h-[50px]",
      },
      werzLogoColor: "#FFFFFF",
      title: "font-['BlurRegular'] text-[26px] leading-[110%] uppercase text-[#ffffff]",
      text: "font-['OriginLightText'] text-[16px] leading-[120%] text-[#ffffff]",
      button:
        "font-['CommitMono400Regular'] text-[14px] leading-[100%] uppercase rounded-[6px] p-4 bg-[#ffffff] text-[#000000] cursor-pointer w-fit",
      input: {
        base: "font-['OriginLightText'] text-[14px] leading-[120%] w-[256px] px-4 h-[48px] bg-[#111111] text-[#ffffff]",
        border: "#444444",
        borderFocus: "#6d6d6d",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['OriginLightText'] text-[14px] leading-[120%] text-[#FF0000]",
      footerText: "font-['OriginLightText'] text-[14px] leading-[120%] text-[#8D8D8D]",
      skipButton:
        "font-['OriginLightText'] text-[14px] leading-[120%] text-[#8D8D8D] cursor-pointer",
      modal: {
        container: "bg-[#111111] px-[40px] py-[48px]",
        title:
          "font-['BlurRegular'] text-[24px] leading-[120%] uppercase text-[#ffffff] text-center",
        text: "font-['OriginLightText'] text-[14px] leading-[120%] text-[#8D8D8D] text-center",
        width: "w-[358px]",
        backdrop: "bg-black/50",
        otpInput:
          "!w-[40px] !h-[50px] rounded-[4px] text-[#ffffff] bg-[#000000] font-['OriginLightText'] text-[16px] leading-[120%] text-center",
        otpBorder: "#444444",
        otpBorderFocus: "#6d6d6d",
      },
    },
    global: {
      counterColor: "#ffffff",
      werzLogoColor: "#ffffff",
      logo: {
        src: `${S3_PREFIX}web-logo.png`,
        styles: "w-[192px] h-[50px]",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[192px] h-[50px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#000000",
      asideBg: "#000000",
      asideStyles: "!p-0 !gap-0 border-r border-[#444444]",
      // Left transparent so the rounded landing/event container paints the black itself —
      // CommunityContentContainer applies contentBg to an outer, un-rounded wrapper.
      contentBg: "",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.jpg`,
      bgMobile: `${S3_PREFIX}web-background-mobile.jpg`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.jpg`,
      mainFont: "font-['OriginLightText']",
      primaryButton:
        "bg-[#ffffff] border border-[#ffffff] rounded-[6px] px-[18px] py-[18px] !text-[#000000] font-['CommitMono400Regular'] !text-[14px] uppercase text-left leading-[100%]",
    },
    navigation: {
      iconsColor: "#ffffff",
      sideBarSeparator: "border-r-[1px] border-[#444444]",
      separator: "border-[#444444]",
      item: "font-['CommitMono400Regular'] text-[16px] text-[#ffffff] uppercase text-left leading-[100%] gap-x-[10px] text-opacity-50 text-center border-b border-[#444444] !pl-0 !py-3",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#000000] rounded-[16px] overflow-hidden !pb-8",
      titles: "text-[#ffffff] font-['BlurRegular'] text-[26px] uppercase text-left leading-[110%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#ffffff] font-['OriginLightText'] text-[13px] text-left leading-[120%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#444444]",
        sectionTitle:
          "text-[#ffffff] font-['BlurRegular'] text-[26px] uppercase text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden !bg-[#ffffff00]",
          mediaContainer: "w-full sm:w-[256px] !h-[256px] relative rounded-[6px] overflow-hidden",
          media: "w-full !h-[256px] object-cover rounded-[6px]",
          placeholderMedia: "w-full !h-[256px] bg-gray-400 rounded-[6px]",
          content: "flex flex-col px-0 py-4 bg-transparent",
          title:
            "text-[#ffffff] font-['BlurRegular'] text-[14px] uppercase text-left leading-[110%]",
          subtitle:
            "text-[#ffffff] font-['OriginLightText'] text-[11px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#444444]",
        sectionTitle:
          "text-[#ffffff] font-['BlurRegular'] text-[26px] uppercase text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden !bg-[#ffffff00]",
          mediaContainer:
            "w-full sm:!w-[228px] !h-[128px] sm:flex-shrink-0 relative rounded-[6px] overflow-hidden",
          media: "w-full !h-[128px] object-cover rounded-[6px]",
          placeholderMedia: "w-full !h-[128px] bg-gray-400 rounded-[6px]",
          content: "flex flex-col px-0 sm:px-4 py-4 sm:!py-0 bg-transparent",
          title:
            "text-[#ffffff] font-['BlurRegular'] text-[14px] uppercase text-left leading-[110%]",
          subtitle:
            "text-[#ffffff] font-['OriginLightText'] text-[11px] text-left leading-[120%] mt-2",
          location:
            "text-[#ffffff] font-['OriginLightText'] text-[11px] text-left leading-[120%] mt-1",
          date: "text-[#ffffff] font-['OriginLightText'] text-[11px] text-left leading-[120%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#ffffff] font-['BlurRegular'] text-[24px] uppercase text-left leading-[110%]",
        text: "text-[#ffffff] font-['OriginLightText'] text-[16px] text-left leading-[120%]",
        customShopImageStyle: "rounded-[6px] overflow-hidden",
        sectionTitle:
          "text-[#ffffff] font-['BlurRegular'] text-[26px] uppercase text-left leading-[110%] !mb-4 sm:mb-6",
      },
    },
    // Shop page (/c/ase-080/shop). Mapped from Figma "Community / Web" ->
    // Module / Shop / Desktop (1158:25303, 1158:14862) and / Mobile (1434:19728).
    // Rows are separated by 1px #444444 dividers, never boxed.
    shopV2: {
      container: "flex flex-col !bg-[#000000] rounded-[16px] overflow-hidden !pb-8",
      header:
        "text-[#ffffff] font-['BlurRegular'] text-[26px] uppercase text-left leading-[110%] px-4 sm:px-8 pt-4 sm:pt-8",
      emptyState:
        "text-[#ffffff] font-['OriginLightText'] text-[16px] text-left leading-[120%] px-4 sm:px-8 py-8",
      eventSection: {
        container: "px-4 sm:px-8 py-4 sm:py-8 border-b border-[#444444]",
        header:
          "text-[#ffffff] font-['BlurRegular'] text-[24px] uppercase text-left leading-[110%] mb-6",
        event: {
          container: "flex items-start gap-x-3 mb-6",
          dateBox:
            "bg-[#ffffff] border border-[#6d6d6d] rounded-[6px] p-1 w-[68px] h-[68px] flex flex-col items-center justify-center text-center shrink-0",
          month:
            "text-[#000000] font-['BlurRegular'] text-[14px] uppercase leading-[110%] text-center",
          day: "text-[#000000] font-['BlurRegular'] text-[14px] uppercase leading-[110%] text-center",
          details: "flex-1 min-w-0",
          name: "text-[#ffffff] font-['BlurRegular'] text-[14px] uppercase text-left leading-[110%]",
          date: "text-[#ffffff] font-['OriginLightText'] text-[11px] text-left leading-[120%] mt-2",
          location:
            "text-[#ffffff] font-['OriginLightText'] text-[11px] text-left leading-[120%] mt-1",
        },
        tickets: {
          container: "flex flex-col overflow-hidden",
          ticket: {
            container:
              "flex flex-row justify-between items-start gap-x-4 leading-auto border-b border-[#444444] py-3",
            mediaContainer: "w-[64px] h-[64px] rounded-[6px] overflow-hidden shrink-0 mr-3",
            media: "w-[64px] h-[64px] object-cover rounded-[6px]",
            name: "text-[#ffffff] font-['BlurRegular'] text-[14px] uppercase text-left leading-[110%]",
            description:
              "text-[#ffffff] font-['OriginLightText'] text-[13px] text-left leading-[120%] mt-1",
            price:
              "text-[#ffffff] font-['BlurRegular'] text-[14px] uppercase text-left leading-[110%] mt-1",
            quantity:
              "text-[#ffffff] font-['CommitMono400Regular'] text-[12px] uppercase text-left leading-[100%]",
            status:
              "text-[#ffffff] font-['BlurRegular'] text-[14px] uppercase text-left leading-[110%]",
            counterContainer:
              "bg-[#000000] border border-[#ffffff] rounded-[6px] px-[12px] py-[12px] gap-x-[16px] !w-fit !h-9",
            plusMinusColor: "#ffffff",
            button:
              "bg-[#000000] border border-[#ffffff] rounded-[6px] px-[12px] py-[12px] text-[#ffffff] font-['CommitMono400Regular'] text-[12px] uppercase text-left leading-[100%] !w-fit",
            descriptionCutoff: 50,
          },
        },
      },
      membershipSection: {
        container: "px-4 sm:px-8 py-4 sm:py-8 border-b border-[#444444]",
        header:
          "text-[#ffffff] font-['BlurRegular'] text-[24px] uppercase text-left leading-[110%] mb-6",
        products: {
          container: "flex flex-col overflow-hidden",
          product: {
            // No media in the memberships rows in the design.
            container:
              "flex flex-row justify-between items-start gap-x-4 leading-auto border-b border-[#444444] py-3",
            mediaContainer: "!hidden",
            media: "!hidden",
            name: "text-[#ffffff] font-['BlurRegular'] text-[14px] uppercase text-left leading-[110%]",
            description:
              "text-[#ffffff] font-['OriginLightText'] text-[13px] text-left leading-[120%] mt-1",
            price:
              "text-[#ffffff] font-['BlurRegular'] text-[14px] uppercase text-left leading-[110%] mt-1",
            quantity:
              "text-[#ffffff] font-['CommitMono400Regular'] text-[12px] uppercase text-left leading-[100%]",
            status:
              "text-[#ffffff] font-['BlurRegular'] text-[14px] uppercase text-left leading-[110%]",
            counterContainer:
              "bg-[#000000] border border-[#ffffff] rounded-[6px] px-[12px] py-[12px] gap-x-[16px] !w-fit !h-9",
            plusMinusColor: "#ffffff",
            // Subscribe is the inverted (primary) button in the design, unlike Buy.
            button:
              "bg-[#ffffff] border border-[#ffffff] rounded-[6px] px-[12px] py-[12px] text-[#000000] font-['CommitMono400Regular'] text-[12px] uppercase text-left leading-[100%] !w-fit",
            descriptionCutoff: 50,
          },
        },
      },
      merchSection: {
        container: "px-4 sm:px-8 py-4 sm:py-8",
        header:
          "text-[#ffffff] font-['BlurRegular'] text-[24px] uppercase text-left leading-[110%] mb-6",
        products: {
          container: "grid grid-cols-2 sm:grid-cols-4 gap-4",
          product: {
            container: "cursor-pointer !bg-[#ffffff00] overflow-hidden",
            innerContainer: "flex flex-col",
            mediaContainer: "w-full rounded-[6px] overflow-hidden",
            media: "w-full !aspect-square object-cover rounded-[6px]",
            name: "text-[#ffffff] font-['BlurRegular'] text-[14px] uppercase text-left leading-[110%] mt-3",
            description:
              "text-[#ffffff] font-['OriginLightText'] text-[11px] text-left leading-[120%] mt-1",
            price:
              "text-[#ffffff] font-['BlurRegular'] text-[14px] uppercase text-left leading-[110%] mt-1",
            quantity:
              "text-[#ffffff] font-['CommitMono400Regular'] text-[11px] uppercase text-left leading-[100%]",
            status:
              "text-[#ffffff] font-['BlurRegular'] text-[14px] uppercase text-left leading-[110%]",
            counterContainer:
              "bg-[#000000] border border-[#ffffff] rounded-[6px] px-[12px] py-[12px] gap-x-[8px] !w-fit !h-8",
            plusMinusColor: "#ffffff",
            button:
              "bg-[#000000] border border-[#ffffff] rounded-[6px] px-[12px] py-[12px] text-[#ffffff] font-['CommitMono400Regular'] text-[11px] uppercase text-left leading-[100%] !w-fit",
            descriptionCutoff: 50,
          },
        },
      },
    },
    // Links (/l/ase-080). Mapped per .agents/skills/onboard-community/references/wm.md#links-page: layout shapes from
    // radioradio, typography from the MM atoms in mm/src/utils/styling/communities/asense.ts,
    // fills/borders/buttons from the WM atoms above. Compact rows use the 6px media radius,
    // not the 16px content-container radius.
    linktree: {
      bgDesktop: `${S3_PREFIX}web-background-non-member.jpg`,
      bgMobile: `${S3_PREFIX}web-background-non-member.jpg`,
      bgColor: "#000000",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative bg-[#000000] p-[64px]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[2.5px] border-[#444444]",
        name: "text-[26px] mt-2 text-[#ffffff] font-['BlurRegular'] uppercase leading-[110%]",
        location:
          "text-[16px] text-[#ffffff] font-['OriginLightText'] leading-[120%] mb-2 text-center",
        description:
          "text-[16px] text-[#ffffff] font-['OriginLightText'] leading-[120%] text-center mb-4",
        socialMediaIconColor: "#ffffff",
        button:
          "flex justify-center items-center bg-[#000000] border border-[#ffffff] rounded-[6px] px-[12px] py-[12px] text-[#ffffff] font-['CommitMono400Regular'] text-[12px] uppercase leading-[100%] cursor-pointer",
      },
      upcomingEvents: {
        header:
          "text-[22px] mb-[10px] text-center text-[#ffffff] font-['BlurRegular'] uppercase leading-[110%]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        loadingState:
          "mb-[32px] bg-[#000000] text-[#ffffff] font-['OriginLightText'] text-[16px] leading-[120%] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border border-[#444444] rounded-[6px]",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] rounded-[6px] bg-[#000000] border border-[#444444] flex flex-col justify-center items-center p-[34px] mb-[32px]",
          title: "text-[#ffffff] font-['BlurRegular'] text-[14px] uppercase leading-[110%] mb-1",
          text: "text-[#ffffff] font-['OriginLightText'] text-[13px] leading-[120%]",
          button:
            "flex justify-center items-center mt-4 bg-[#000000] border border-[#ffffff] rounded-[6px] px-[12px] py-[12px] text-[#ffffff] font-['CommitMono400Regular'] text-[12px] uppercase leading-[100%] cursor-pointer",
        },
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] bg-[#000000] rounded-[6px] flex justify-between border border-[#444444]",
          name: "text-[16px] leading-[110%] text-[#ffffff] font-['BlurRegular'] uppercase one-line-truncate sm:w-[390px] w-[65vw]",
          duration: "text-[#ffffff] font-['OriginLightText'] text-[11px] leading-[120%]",
          plusIconColor: "#ffffff",
          media: "border border-[#444444] overflow-hidden rounded-[6px] m-2",
        },
        event: {
          container:
            "border border-[#444444] rounded-[6px] bg-[#000000] overflow-hidden sm:w-[500px] w-[95vw]",
          name: "text-[20px] mb-1 text-[#ffffff] font-['BlurRegular'] uppercase leading-[110%] one-line-truncate sm:w-[370px] w-[60vw]",
          startDate:
            "w-[64px] h-[64px] rounded-[6px] bg-[#ffffff] text-[#000000] flex flex-col justify-center items-center gap-1 font-['CommitMono400Regular'] text-[12px] uppercase leading-[100%]",
          duration: "text-[#ffffff] font-['OriginLightText'] text-[11px] leading-[120%]",
          location: "text-[#ffffff] font-['OriginLightText'] text-[11px] leading-[120%]",
          button:
            "flex justify-center items-center mt-3 bg-[#000000] border border-[#ffffff] rounded-[6px] px-[12px] py-[12px] text-[#ffffff] font-['CommitMono400Regular'] text-[12px] uppercase leading-[100%] cursor-pointer",
          product: {
            container: "h-[68px] border-t border-[#444444] px-4 py-3 flex justify-between",
            name: "text-[#ffffff] font-['BlurRegular'] text-[14px] uppercase leading-[110%] one-line-truncate sm:w-[390px] w-[65vw]",
            price: "text-[#ffffff] font-['BlurRegular'] text-[14px] uppercase leading-[110%]",
            status: "text-[#ffffff] font-['BlurRegular'] text-[14px] uppercase leading-[110%]",
            link: "text-[#ffffff] font-['OriginLightText'] text-[11px] leading-[120%]",
            button:
              "flex justify-center items-center bg-[#000000] border border-[#ffffff] rounded-[6px] px-[12px] py-[12px] text-[#ffffff] font-['CommitMono400Regular'] text-[12px] uppercase leading-[100%] cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#ffffff] font-['OriginLightText'] text-[16px] leading-[120%] text-center mt-4 cursor-pointer mb-[32px]",
      },
      news: {
        header:
          "text-[22px] mb-[10px] text-center text-[#ffffff] font-['BlurRegular'] uppercase leading-[110%]",
        container: "flex flex-col gap-4",
        loadingState:
          "mb-[32px] bg-[#000000] text-[#ffffff] font-['OriginLightText'] text-[16px] leading-[120%] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border border-[#444444] rounded-[6px]",
        oneNews: {
          container:
            "h-[64px] cursor-pointer bg-[#000000] sm:w-[500px] w-[95vw] rounded-[6px] flex justify-between border border-[#444444]",
          name: "text-[16px] leading-[110%] text-[#ffffff] font-['BlurRegular'] uppercase one-line-truncate sm:w-[390px] w-[65vw]",
          created: "text-[#ffffff] font-['OriginLightText'] text-[13px] leading-[120%]",
          triangleIconColor: "#ffffff",
          media: "border border-[#444444] overflow-hidden rounded-[6px] m-2",
        },
        seeAllNews:
          "text-[#ffffff] font-['OriginLightText'] text-[16px] leading-[120%] text-center mt-4 cursor-pointer mb-[32px]",
      },
      radioTracks: {
        header:
          "text-[22px] mb-[10px] text-center text-[#ffffff] font-['BlurRegular'] uppercase leading-[110%]",
        container: "flex flex-col gap-4",
        loadingState:
          "mb-[32px] bg-[#000000] text-[#ffffff] font-['OriginLightText'] text-[16px] leading-[120%] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border border-[#444444] rounded-[6px]",
        radioTrack: {
          container:
            "h-[64px] cursor-pointer bg-[#000000] sm:w-[500px] w-[95vw] rounded-[6px] flex justify-between border border-[#444444]",
          title:
            "text-[16px] leading-[110%] text-[#ffffff] font-['BlurRegular'] uppercase one-line-truncate sm:w-[390px] w-[65vw]",
          duration: "text-[#ffffff] font-['OriginLightText'] text-[13px] leading-[120%]",
          start: "text-[#ffffff] font-['OriginLightText'] text-[13px] leading-[120%]",
          liveType: "text-[#ffffff] font-['CommitMono400Regular'] text-[11px] uppercase",
          liveTypeCircle: "bg-[#ffffff]",
          // MM radio controls: fill #ffffff on stroke #000000
          playIconColor: "#000000",
          playIconBackgroundColor: "#ffffff",
          playIconBorderColor: "#ffffff",
          coverUrl: "border border-[#444444] overflow-hidden rounded-[6px] m-2",
        },
        seeAllTracks:
          "text-[#ffffff] font-['OriginLightText'] text-[16px] leading-[120%] text-center mt-4 cursor-pointer mb-[32px]",
      },
      otherLinks: {
        header:
          "text-[22px] mb-[10px] text-center text-[#ffffff] font-['BlurRegular'] uppercase leading-[110%]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        loadingState:
          "mb-[32px] bg-[#000000] text-[#ffffff] font-['OriginLightText'] text-[16px] leading-[120%] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border border-[#444444] rounded-[6px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] w-[95vw] bg-[#000000] rounded-[6px] flex justify-between border border-[#444444]",
          name: "text-[15px] text-[#ffffff] font-['BlurRegular'] uppercase leading-[110%]",
          triangleIconColor: "#ffffff",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full border border-[#444444] object-cover",
        },
      },
      footer: {
        WERZlogoColor: "#ffffff",
        text: "",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#000000] rounded-[16px] overflow-hidden !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#444444]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 !border-0 rounded-[6px]",
        title: "text-[#ffffff] font-['BlurRegular'] text-[26px] uppercase text-left leading-[110%]",
        subtitle:
          "text-[#ffffff] font-['OriginLightText'] text-[13px] text-left leading-[120%] mb-4 mt-2",
        button:
          "bg-[#ffffff] border border-[#ffffff] rounded-[6px] px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 gap-y-[6px] text-[#000000] font-['CommitMono400Regular'] !text-[14px] uppercase text-left leading-[100%]",
        questions: "text-[13px] leading-[120%] text-left !text-[#ffffff]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#444444]",
        header:
          "text-[#ffffff] font-['BlurRegular'] text-[24px] uppercase text-left leading-[110%]",
        text: "text-[#ffffff] font-['OriginLightText'] text-[13px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#444444]",
        header:
          "text-[#ffffff] font-['BlurRegular'] text-[24px] uppercase text-left leading-[110%]",
        text: "text-[#ffffff] font-['OriginLightText'] text-[13px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden gap-y-[10px]",
        mapPinColor: "#ffffff",
        mapStrokeColor: "#ffffff00",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#ffffff] font-['BlurRegular'] text-[24px] uppercase text-left leading-[110%]",
        text: "text-[#ffffff] font-['OriginLightText'] text-[13px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#ffffff] font-['BlurRegular'] text-[24px] uppercase text-left leading-[110%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#000000] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#000000] border border-[#ffffff] rounded-[6px] px-[12px] py-[12px] text-[#ffffff] font-['CommitMono400Regular'] text-[12px] uppercase text-left leading-[100%] !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#ffffff00] border-b border-[#444444] overflow-hidden py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#ffffff] font-['BlurRegular'] text-[14px] uppercase text-left leading-[110%] mb-1",
          description:
            "text-[#ffffff] font-['OriginLightText'] text-[13px] text-left leading-[120%] mb-1 flex flex-row",
          price:
            "text-[#ffffff] font-['BlurRegular'] text-[14px] uppercase text-left leading-[110%]",
          quantity:
            "text-[#ffffff] font-['CommitMono400Regular'] text-[12px] uppercase text-left leading-[100%]",
          status:
            "text-[#ffffff] font-['BlurRegular'] text-[14px] uppercase text-left leading-[110%]",
          counterContainer:
            "bg-[#000000] border border-[#ffffff] rounded-[6px] px-[12px] py-[12px] gap-x-[16px] !w-fit !h-10",
          plusMinusColor: "#ffffff",
          button:
            "bg-[#000000] border border-[#ffffff] rounded-[6px] px-[12px] py-[12px] text-[#ffffff] font-['CommitMono400Regular'] text-[12px] uppercase text-left leading-[100%] !w-fit",
        },
      },
    },
    // Product details (subscription / merch). Mapped from Figma "Community / Web" ->
    // Module / Shop / Subscription (1278:19158), Merch - size + color (1413:19095),
    // Merch - one-size (1413:20576).
    shopProductV2: {
      container: "flex flex-col !bg-[#000000] rounded-[16px] overflow-hidden sm:p-8 p-4",
      mediaContainer: "w-full rounded-[6px] overflow-hidden",
      media: "w-full sm:!h-[486px] object-cover rounded-[6px]",
      title:
        "text-[#ffffff] font-['BlurRegular'] text-[26px] uppercase text-left leading-[110%] mt-6",
      additionalDetails:
        "text-[#ffffff] font-['OriginLightText'] text-[16px] text-left leading-[120%] mt-4",
      priceSection: "border-t border-[#444444] mt-6 pt-4",
      displayPrice:
        "text-[#ffffff] font-['BlurRegular'] text-[14px] uppercase text-left leading-[110%]",
      shortTerms:
        "text-[#ffffff] font-['OriginLightText'] text-[13px] text-left leading-[120%] mt-1",
      variantSelector: {
        section: "mt-6 space-y-4",
        separator: "flex items-center gap-x-[10px] border-t border-[#444444] pt-4",
        label: "text-[#ffffff] font-['OriginLightText'] text-[13px] leading-[120%]",
        sizeButton:
          "px-[12px] py-[12px] border border-[#ffffff] bg-transparent text-[#ffffff] rounded-[6px] font-['CommitMono400Regular'] text-[11px] uppercase leading-[100%] transition-all",
        sizeButtonSelected:
          "px-[12px] py-[12px] border border-[#ffffff] bg-[#ffffff] text-[#000000] rounded-[6px] font-['CommitMono400Regular'] text-[11px] uppercase leading-[100%]",
        sizeButtonOneSize:
          "px-[12px] py-[12px] border border-[#ffffff] bg-transparent text-[#ffffff] rounded-[6px] font-['CommitMono400Regular'] text-[11px] uppercase leading-[100%] cursor-default",
        colorSwatchContainer: "flex gap-x-[10px] items-center",
        colorSwatch: "w-8 h-8 rounded-full border border-[#ffffff] transition-all",
        colorSwatchSelected: "w-8 h-8 rounded-full border-2 border-[#ffffff] transition-all",
        validationMessage:
          "text-[#ffffff] font-['OriginLightText'] text-[13px] leading-[120%] mt-2 border-t border-[#444444] pt-4",
      },
      counter: {
        container:
          "flex items-center gap-x-[16px] border border-[#ffffff] bg-[#000000] rounded-[6px] px-[12px] py-[12px] !h-9",
        quantity:
          "text-[#ffffff] font-['CommitMono400Regular'] text-[12px] uppercase leading-[100%] min-w-[20px] text-center",
        plusMinusColor: "#ffffff",
      },
      // Bottom CTA ("Subscribe" / "Go to checkout") is the inverted primary button.
      button:
        "bg-[#ffffff] border border-[#ffffff] rounded-[6px] px-[18px] py-[18px] text-[#000000] font-['CommitMono400Regular'] !text-[14px] uppercase text-left leading-[100%] !w-fit mt-8 border-t-[#444444]",
    },
  },
}

export default ASENSE
